/* eslint-disable no-plusplus */
/* eslint-disable arrow-body-style */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-continue */
import { useEffect, useState } from 'react';
import packageJson from '../package.json';

const appVersion = packageJson.version;

const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g);
    const versionsB = versionB.split(/\./g);

    while (versionsA.length || versionsB.length) {
        const partA = Number(versionsA.shift());
        const partB = Number(versionsB.shift());
        console.log('hello versionsA= ', partA, 'versionsB= ', partB);

        if (partA === partB) continue;

        return partA > partB || isNaN(partB);
    }

    return false;
};

function isVersionGreater(v1, v2) {
    const v1Parts = v1.split('.').map(Number);
    const v2Parts = v2.split('.').map(Number);

    for (let i = 0; i < 3; i++) {
        if (v1Parts[i] > v2Parts[i]) return true;
        if (v1Parts[i] < v2Parts[i]) return false;
    }

    return false; // versions are equal
}

const CacheBuster = ({ children }) => {
    const ENV = process.env.REACT_APP_ENV;
    const [loading, setLoading] = useState(true);
    const [isLatestVersion, setIsLatestVersion] = useState(false);

    const refreshCacheAndReload = () => {
        console.log('version :: hello Clearing cache and hard reloading...');

        if (caches) {
            caches.keys().then(function (names) {
                for (const name of names) caches.delete(name);
            });
        }
        window.location.replace(window.location.href);
        console.log('version :: hello trying to reload due to version mismatch');
    };

    useEffect(() => {
        if (ENV === 'local') {
            setLoading(false);
            return;
        }
        fetch(`/meta.json`, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        })
            .then((response) => {
                return response.json();
            })
            .then((meta) => {
                const latestVersion = meta.version;
                const currentVersion = appVersion;
                console.log(`version ::  package currentVersion :: ${currentVersion}.  meta latestVersion ::  ${latestVersion} `);
                const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
                console.log(`version :: isVersionGreater::`, shouldForceRefresh);
                if (shouldForceRefresh) {
                    console.log(`version :: We have a new version - ${latestVersion}. Should force refresh`);
                    setIsLatestVersion(false);
                } else {
                    console.log(`version :: You already have the latest version - ${latestVersion}. No cache refresh needed.`);
                    setIsLatestVersion(true);
                }
                setLoading(false);
            });
    }, []);

    if (loading) return null;

    if (!loading && !isLatestVersion && ENV !== 'local') {
        refreshCacheAndReload();
    }

    return children({ loading, isLatestVersion, refreshCacheAndReload });
};

export default CacheBuster;
